package br.com.vvrefeicoes.portal.domain.model

data class EntityFinancials(
    val name: String,
    val monthly: List<MonthlyFinancials>,
    val periodTotals: List<MonthlyFinancials> = monthly,
) {
    val totalRevenueCents: Long
        get() = periodTotals.sumOf { it.revenueCents }

    val totalExpenseCents: Long
        get() = periodTotals.sumOf { it.expenseCents }

    val totalResultCents: Long
        get() = totalRevenueCents - totalExpenseCents
}
